var map = {
	"./en.yml": [
		23161,
		[
			23161
		]
	],
	"./es.yml": [
		1420,
		[
			1420
		]
	],
	"./fr.yml": [
		59768,
		[
			59768
		]
	],
	"./ja.yml": [
		79899,
		[
			79899
		]
	],
	"./zh-CN.yml": [
		63892,
		[
			63892
		]
	],
	"./zh-TW.yml": [
		31788,
		[
			31788
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(() => {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1][0]).then(() => (__webpack_require__.t(id, 7 | 16)));
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 50092;
module.exports = webpackAsyncContext;